// extracted by mini-css-extract-plugin
export default {"header":"header___oWPMV","avatar":"avatar___dF5NK"};